import type { ICarePlanPrechartEnvelope } from "../../../core/ports/driver/VisitNotesService";

export const buildCarePlanPrechartUrl = (
  routeTemplate: string,
  clinicId: number,
  patientId: number,
  noteId: number
): string =>
  routeTemplate
    .replace("{clinic_id}", clinicId.toString())
    .replace("{patient_id}", patientId.toString())
    .replace("{note_id}", noteId.toString());

export class CarePlanPrechartApiError extends Error {
  code?: string;

  constructor(message: string, code?: string) {
    super(message);
    this.name = "CarePlanPrechartApiError";
    this.code = code;
  }
}

export const parseCarePlanPrechartResponse = (
  response: any,
  fallbackMessage: string
): ICarePlanPrechartEnvelope => {
  const envelope = response?.data || response;
  if (envelope?.prechart_care_plan && envelope?.note_id != null) {
    return envelope as ICarePlanPrechartEnvelope;
  }

  const detail = envelope?.detail;
  const message =
    (typeof detail === "string" ? detail : detail?.message) ||
    envelope?.message ||
    fallbackMessage;
  const responseCode =
    detail?.code || detail?.error || envelope?.code || envelope?.error;
  const isConflict =
    envelope?.status === 409 ||
    responseCode === "revision_conflict" ||
    /conflict|stale|revision/i.test(message);

  throw new CarePlanPrechartApiError(
    message,
    isConflict ? "revision_conflict" : responseCode
  );
};
